const config = {
    baseApi: process.env.VUE_APP_BASE_API || "http://0.0.0.0:7010",
    // Sidecar de IA (chatbot). Vacío = el widget no se monta (feature flag).
    aiAPI: process.env.VUE_APP_AI_URL || "",
    sentryDsn: process.env.VUE_APP_SENTRY_DSN_FRONTEND || "",
    webhookAPI: process.env.VUE_APP_WEBHOOK_URL || process.env.VUE_APP_BASE_API,
    chitaUrl: process.env.VUE_APP_CHITA_URL || "https://chita.cl",
    devServer: {
        host: "0.0.0.0",
        public: "0.0.0.0:80",
        disableHostCheck: true,
    },
};

export default config;
